<div #chartContainer class="jepto-area-chart-container"></div>
